module.exports = __webpack_public_path__ + "media/video202.01895be8.mp4";